import { FaFacebook, FaInstagram, FaTiktok, FaEnvelope } from 'react-icons/fa';

// Get platform color
export const getPlatformColor = (platform: string): string => {
  const colors: Record<string, string> = {
    facebook: '#1877F2',
    instagram: '#E1306C',
    'instagram-direct': '#E1306C',
    tiktok: '#00F2EA',
    email: '#EE4423',
  };
  return colors[platform.toLowerCase()] || '#EE4423';
};

// Get platform icon
export const getPlatformIcon = (platform: string) => {
  const platformLower = platform.toLowerCase();
  const color = getPlatformColor(platform);
  
  if (platformLower === 'facebook') {
    return <FaFacebook className="text-xl" style={{ color }} />;
  } else if (platformLower === 'instagram' || platformLower === 'instagram-direct') {
    return <FaInstagram className="text-xl" style={{ color }} />;
  } else if (platformLower === 'tiktok') {
    return <FaTiktok className="text-xl" style={{ color }} />;
  } else if (platformLower === 'email') {
    return <FaEnvelope className="text-xl" style={{ color }} />;
  }
  return <FaEnvelope className="text-xl" style={{ color }} />;
};

// Format analytics value
export const formatValue = (value: number): string => {
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}k`;
  }
  return value.toString();
};

// Get flyer URL
export const getFlyerUrl = (campaign: any): string => {
  return campaign.flyer?.image?.storage_url || '';
};
